import { Controller } from "@hotwired/stimulus"

// 드롭다운 토글 컨트롤러
// 사용 예시:
// <div data-controller="dropdown">
//   <button data-action="click->dropdown#toggle">Toggle</button>
//   <div data-dropdown-target="menu" class="hidden">Menu content</div>
// </div>
export default class extends Controller {
  static targets = ["menu"]

  connect() {
    // 외부 클릭 감지를 위한 바인딩
    this.handleClickOutside = this.handleClickOutside.bind(this)
  }

  disconnect() {
    document.removeEventListener('click', this.handleClickOutside)
  }

  toggle(event) {
    event.stopPropagation()

    if (this.hasMenuTarget) {
      const isHidden = this.menuTarget.classList.contains('hidden')

      if (isHidden) {
        this.show()
      } else {
        this.hide()
      }
    }
  }

  show() {
    if (this.hasMenuTarget) {
      this.menuTarget.classList.remove('hidden')
      // 외부 클릭 감지 활성화
      setTimeout(() => {
        document.addEventListener('click', this.handleClickOutside)
      }, 0)
    }
  }

  hide() {
    if (this.hasMenuTarget) {
      this.menuTarget.classList.add('hidden')
      document.removeEventListener('click', this.handleClickOutside)
    }
  }

  handleClickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.hide()
    }
  }
}
